    //import anime from 'animejs'

    jQuery(document).ready(function () {
      
    
        topScrollUp();
        navigator();
        $(window).on("scroll", revealContent);
        polyLangDropDown();
        songFilter();

    });


    const topScrollUp = () => {
        $(window).scroll(function () {
          if ($(this).scrollTop() > 800) {
            $('#scrollTopBtn').fadeIn();
          } else {
            $('#scrollTopBtn').fadeOut();
          }
        });

        // Click to scroll to top
        $('#scrollTopBtn').click(function () {
          $('html, body').animate({ scrollTop: 0 }, 600);
          return false;
        });
    };



    const navigator = () => {
        $('#burger-menu').on('click', function() {
        $('#mobile-menu').toggleClass('active');
        $('#overlay').toggleClass('active');
        $(this).toggleClass('active');
      });

      $('#overlay').on('click', function() {
        $('#mobile-menu').removeClass('active');
        $('#overlay').removeClass('active');
        $('#burger-menu').removeClass('active');
      });
    };




    function revealContent() {
        let reveals = $(".reveal");
        let elementVisible = -40;
        let windowHeight = window.innerHeight

        reveals.each(function () {
            let elementTop = this.getBoundingClientRect().top;
            if (!this.classList.contains("active") && elementTop < windowHeight + elementVisible) {
                this.classList.add("active");
            }
        });
    }


    function polyLangDropDown() {
        const dropdown = $('.poly-custom-language-dropdown');
        const toggleButton = dropdown.find('.poly-dropdown-toggle');

        // Toggle dropdown on button click
        toggleButton.on('click', function (e) {
            e.stopPropagation();
            dropdown.toggleClass('open');
        });

        // Close dropdown when clicking outside
        $(document).on('click', function (e) {
            if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0) {
                dropdown.removeClass('open');
            }
        });
    }



    function songFilter() {


      $('.song-form').on('submit', function(e) {
            e.preventDefault();
            $('.response-message').html('');

            const musicLink = $('input[name="music_link"]').val();

                  $.ajax({
                  url: ajax.url, // This is from your existing localization
                  type: 'POST',
                  data: {
                    action: 'submit_song_request',
                    music_link: musicLink,
                    nonce: songRequestData.nonce // This is from the new localization
                  },
      success: function(response) {
        $('.response-message').html('<div class="message success">' + response.data.message + '</div>');
        $('input[name="music_link"]').val('');
      },
      error: function(response) {
        $('.response-message').html('<div class="message error">' + response.responseJSON.data.message + '</div>');
      }
    });
        });
    }
